export default __webpack_public_path__ + "static/media/sensotrend_uploader_scroll.b4efbca8.png";